import { encodeParams } from 'mailup-react-helpers'

import apiWrapper from 'Helpers/apiWrapper'

import {
  type ContactOpportunity,
  type GetSessionOauth2TokenQsParams,
  type SessionTokenResponse,
  type User
} from 'Types/beAccountSettingsApi'

const endpoints = ((baseURL: string) => {
  return {
    getUser: (idUser: number) => `${baseURL}/api/users/${idUser}`,
    sendContactRequest: `${baseURL}/api/adm/notifyevent/opportunity`,
    //  Session
    getSessionOauth2Token: (qs: GetSessionOauth2TokenQsParams) =>
      `${baseURL}/api/session/oauth2?${encodeParams(qs) as string}`,
  }
})(process.env.BEACCOUNTSETTINGS_URL as string)

export const beAccountSettingsApiGetUser = async (
  idUser: number
): Promise<User | null> => {
  const url = endpoints.getUser(idUser)

  return await apiWrapper({
    method: 'get',
    url,
  }).then((res) => res.data)
}

export const beAccountSettingsApiSendContactRequest = async (
  data: ContactOpportunity
): Promise<boolean | null> => {
  const url = endpoints.sendContactRequest

  return await apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify(data),
  }).then((res) => res.data)
}

export const beAccountSettingsApiGetSessionOauth2Token = async (
  qs: GetSessionOauth2TokenQsParams
): Promise<SessionTokenResponse> => {
  const response = await fetch(endpoints.getSessionOauth2Token(qs))

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`)
  }

  return await response.json()
}
